// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2298":"287485c7","3608":"9094b139","4212":"ef16b192","5927":"23c629ea","9426":"f2f066b7"}[chunkId] + ".chunk.css";
};